module.exports = __webpack_public_path__ + "static/media/add-representative.de8f1825.svg";